import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "./Logo";

const services = [
  "Company Accounts & CT",
  "Self Assessment",
  "Bookkeeping",
  "VAT Returns",
  "CIS",
  "Payroll",
];
const company = ["About", "Pricing", "How it works", "Contact"];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-white text-[#2A3430] border-t border-[#2A3430]/10"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <Logo variant="dark" />
          <p className="mt-5 text-sm text-[#2A3430]/70 max-w-sm leading-relaxed">
            Online accountants for sole traders, limited companies and
            ambitious founders. Cloud-first. MTD-ready.
          </p>
          <div className="mt-6 flex flex-col gap-2 text-sm text-[#2A3430]/80">
            <a
              href="mailto:ahmed@xabaccountants.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 hover:text-[#C57A5A] transition"
            >
              <Mail className="h-4 w-4" /> ahmed@xabaccountants.com
            </a>
            <a
              href="tel:+442080640905"
              data-testid="footer-phone"
              className="inline-flex items-center gap-2 hover:text-[#C57A5A] transition"
            >
              <Phone className="h-4 w-4" /> 020 8064 0905
            </a>
            <span className="inline-flex items-center gap-2 text-[#2A3430]/60">
              <MapPin className="h-4 w-4" /> United Kingdom · Online practice
            </span>
          </div>

          <div className="mt-7 flex items-center gap-3">
            <span
              data-testid="footer-aat-badge"
              className="inline-flex items-center justify-center bg-[#2A3430] rounded-lg px-3 py-2"
              title="MAAT — Member of the Association of Accounting Technicians"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_xab-uk-accounts/artifacts/5oqvol6m_aat-logo-white.png"
                alt="AAT Licensed Accountant"
                className="h-6 w-auto"
                loading="lazy"
              />
            </span>
            <span className="text-[11px] uppercase tracking-[0.18em] text-[#2A3430]/60">
              Licensed Accountant
            </span>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#2A3430]/55 font-medium">
            Services
          </h4>
          <ul className="mt-4 space-y-2.5">
            {services.map((s) => (
              <li key={s}>
                <a
                  href="#services"
                  className="text-sm text-[#2A3430]/80 hover:text-[#C57A5A] transition"
                  data-testid={`footer-service-${s.toLowerCase().replace(/\s|&/g, "-")}`}
                >
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#2A3430]/55 font-medium">
            Company
          </h4>
          <ul className="mt-4 space-y-2.5">
            {company.map((c) => (
              <li key={c}>
                <a
                  href={`#${c.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-[#2A3430]/80 hover:text-[#C57A5A] transition"
                  data-testid={`footer-company-${c.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-[#2A3430]/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-[#2A3430]/55">
          © {new Date().getFullYear()} Xab Accountants. All rights reserved.
        </p>
        <p
          data-testid="footer-languages"
          className="text-xs text-[#2A3430]/70 inline-flex items-center gap-2"
        >
          <span>We speak</span>
          <span className="inline-flex items-center gap-1.5">
            <img
              src="https://flagcdn.com/gb.svg"
              alt="English (UK)"
              className="h-5 w-7 object-cover rounded-sm ring-1 ring-[#2A3430]/10"
              loading="lazy"
            />
            <img
              src="https://flagcdn.com/sa.svg"
              alt="Arabic (Saudi Arabia)"
              className="h-5 w-7 object-cover rounded-sm ring-1 ring-[#2A3430]/10"
              loading="lazy"
            />
            <img
              src="https://flagcdn.com/so.svg"
              alt="Somali"
              className="h-5 w-7 object-cover rounded-sm ring-1 ring-[#2A3430]/10"
              loading="lazy"
            />
          </span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
